import React from 'react';

const FormField = ({ icon, label, type, id, value, onChange, placeholder, children, readOnly, required }) => (
  <div>
    <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-2 flex items-center">
      {icon && <span className="mr-2 text-blue-600">{icon}</span>}
      {label}
    </label>
    {type === 'select' ? (
      <select
        id={id}
        className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
        value={value}
        onChange={onChange}
      >
        {children}
      </select>
    ) : (
      <input
        type={type}
        id={id}
        className={`w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 ${readOnly ? 'bg-white-100' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
      />
    )}
  </div>
);

export default FormField;